import Vue from "vue";
import VueResource from "vue-resource";
import Store from "@/store";

import encryptation from "@/services/mixins/encryptation";

Vue.use(VueResource);

function interceptor() {
  Vue.http.interceptors.push((request, next) => {
    const cache = localStorage.getItem("cache");
    if (cache) {
      const token = encryptation.methods.decrypt(cache.toString());
      request.headers.set("Authorization", `bearer ${token.jwt.access_token}`);
    }

    next(response => {
      if (response.status === 403) {
        return new Promise((resolve, reject) => {
          Vue.http.post("auth/refresh").then(
            res => {
              const newCache = {
                ...encryptation.methods.decrypt(cache.toString())
              };

              newCache.jwt = res.body.data;
              Store.commit("User/updateToken", newCache.jwt.access_token);
              const newCrypt = encryptation.methods.encrypt(newCache);

              localStorage.setItem("cache", newCrypt.toString());

              request.headers.set(
                "Authorization",
                `bearer ${res.body.data.access_token}`
              );

              Vue.http(request).then(
                resp => {
                  resolve(resp);
                },
                error => reject(error)
              );
            },
            error => {
              localStorage.clear();
              localStorage.setItem("error-session", true);
              document.location.href = "/login";
            }
          );
        });
      }
      // check return
      return "";
    });
  });
}

export default interceptor;
